// Links externos da tela de planos, por ambiente (Environments do GitHub do portal).
// Vazio esconde o link. As variáveis entram no bundle na hora do build (webpack), então
// preencher um link novo exige novo deploy do portal.
export const BLACK_NOVEMBER_RULES_URL = process.env.BLACK_NOVEMBER_RULES_URL || ''
export const IA4COM_INFO_URL = process.env.IA4COM_INFO_URL || ''



// WEBPACK FOOTER //
// ./src/utils/campaign-links.js